import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { showManageLeftFilters } from 'store/Manage/actions';
import { showHostLeftFilters } from 'store/Host/actions';
import { selectShowManageLeftFilters } from 'store/Manage/selectors';
import { selectShowHostLeftFilters } from 'store/Host/selectors';
import { selectIsFiltering } from 'store/Filters/selectors';
import IconButton from 'Common/Components/IconButton';
import { DisabledFilterIcon, EnabledFilterIcon } from './styled';

const FilterSideBarIcon = ({ entity }) => {
  const dispatch = useDispatch();
  const isFiltering = useSelector((state) => selectIsFiltering(entity, state));
  const showFilters = useSelector((state) => {
    if (entity === 'vulns') return selectShowManageLeftFilters(state);
    if (entity === 'assets') return selectShowHostLeftFilters(state);
    return false;
  });

  const setShowFilter = () => {
    if (entity === 'vulns') dispatch(showManageLeftFilters(true, false));
    else if (entity === 'assets') dispatch(showHostLeftFilters(true));
  };

  const setHideFilter = () => {
    if (entity === 'vulns') dispatch(showManageLeftFilters(false, false));
    else if (entity === 'assets') dispatch(showHostLeftFilters(false));
  };

  const handleClick = () => (showFilters ? setHideFilter() : setShowFilter());

  return (
    <>
      {!isFiltering && <IconButton icon={ <DisabledFilterIcon /> } title="Filters" onClick={ handleClick } />}
      {isFiltering && <IconButton icon={ <EnabledFilterIcon /> } title="Filters" onClick={ handleClick } />}
    </>
  );
};

FilterSideBarIcon.propTypes = {
  entity: PropTypes.string.isRequired
};

export default FilterSideBarIcon;
